// Initials for a local avatar (design evaluation F15); drawn by ds-zta's InitialsAvatar.

const LETTER = /[\p{L}\p{N}]/u;

function firstLetter(word: string): string {
  const ch = Array.from(word).find((c) => LETTER.test(c));
  return ch ? ch.toLocaleUpperCase() : "";
}

/**
 * Up to two initials: first and last word of the name ("Ada Lovelace" -> "AL",
 * "Ada" -> "A"); without a name, the email's local part split on . _ - +
 * ("ada.lovelace@x.io" -> "AL"). "?" when neither has a letter or digit.
 */
export function initialsFor(name?: string | null, email?: string | null): string {
  const fromWords = (words: string[]) => {
    const w = words.map(firstLetter).filter(Boolean);
    if (w.length === 0) return "";
    return w.length === 1 ? w[0] : w[0] + w[w.length - 1];
  };
  const byName = fromWords((name ?? "").trim().split(/\s+/));
  if (byName) return byName;
  const local = (email ?? "").split("@")[0];
  return fromWords(local.split(/[._+\-\s]+/)) || "?";
}
